var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRegulation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3581 24.7608C56.0235 24.7608 55.6974 24.6628 55.42 24.4768C52.3964 22.4553 48.8403 21.3788 45.2031 21.3805H26.6762C23.0355 21.3772 19.4779 22.4538 16.4507 24.4768C15.9884 24.7815 15.4113 24.8413 14.9011 24.6448C14.8058 24.6081 14.7117 24.5679 14.6143 24.5373L5.88004 21.7936C4.89366 21.4837 4.41852 20.365 4.88047 19.44C5.24503 18.71 6.08135 18.3475 6.86332 18.5805L14.5785 20.8792C15.1186 21.0401 15.6991 20.9614 16.1929 20.6899C19.4002 18.9263 23.0062 17.9984 26.6762 18H45.2031C48.8778 17.9969 52.4873 18.9248 55.6979 20.6899C56.1918 20.9614 56.7725 21.04 57.3126 20.879L65.0192 18.5809C65.8012 18.3477 66.6376 18.7101 67.0022 19.4402C67.4641 20.365 66.989 21.4837 66.0028 21.7935L57.2746 24.5353C57.173 24.5672 57.0751 24.6096 56.9757 24.6479C56.7795 24.7236 56.5698 24.7621 56.3581 24.7608Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 15H33V72H39V15Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2818 72.7606H26L33 66H39L46.2818 72.7606Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 57L57.9755 20.8517C57.9483 20.7537 57.8092 20.7541 57.7826 20.8523L48 57",
    stroke: "#D7AE88",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 57L14.9755 20.8517C14.9483 20.7537 14.8092 20.7541 14.7826 20.8523L5 57",
    stroke: "#D7AE88",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3804 13.5211H32.6199L30.8791 6.55938C30.1709 3.73184 31.8898 0.865235 34.7191 0.157227C35.1382 0.0523437 35.5693 0 36.0002 0C38.9156 0 41.2785 2.36289 41.2785 5.27832C41.2785 5.71094 41.2261 6.14024 41.1213 6.55938L39.3804 13.5211Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6954 0.000488281C36.2345 0.00888672 36.7687 0.100293 37.2808 0.270996C34.6239 1.10264 33.0739 3.85908 33.745 6.56006L35.4841 13.5218H32.3151L30.5743 6.56006C29.8661 3.73252 31.5851 0.865918 34.4144 0.15791C34.8317 0.0545899 35.2626 0.000488281 35.6954 0.000488281Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.761 11.8311H29.2399C28.3065 11.8311 27.5498 12.5878 27.5498 13.5212C27.5498 14.4546 28.3065 15.2113 29.2399 15.2113H42.761C43.6945 15.2113 44.4512 14.4546 44.4512 13.5212C44.4512 12.5878 43.6945 11.8311 42.761 11.8311Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 47C71.1046 47 72.0124 47.8996 71.8843 48.9967C70.963 56.8909 64.6504 63 57 63C49.3496 63 43.037 56.8909 42.1157 48.9967C41.9876 47.8996 42.8954 47 44 47H70Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 47C71.1046 47 72.0124 47.8996 71.8843 48.9967C70.963 56.8909 64.6504 63 57 63C49.3496 63 43.037 56.8909 42.1157 48.9967C41.9876 47.8996 42.8954 47 44 47H70Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 47C29.1046 47 30.0124 47.8996 29.8843 48.9967C28.963 56.8909 22.6504 63 15 63C7.34965 63 1.03697 56.8909 0.115664 48.9967C-0.0123771 47.8996 0.895431 47 2 47H28Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 47C29.1046 47 30.0124 47.8996 29.8843 48.9967C28.963 56.8909 22.6504 63 15 63C7.34965 63 1.03697 56.8909 0.115664 48.9967C-0.0123771 47.8996 0.895431 47 2 47H28Z",
    fill: "#B0D2EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 47C71.1046 47 72.0124 47.8996 71.8843 48.9967C70.963 56.8909 64.6504 63 57 63C62.0711 61.1559 66.2917 56.6226 66.9191 49.0003C67.0097 47.8995 67.8949 47 68.9995 47H70Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 47C71.1046 47 72.0124 47.8996 71.8843 48.9967C70.963 56.8909 64.6504 63 57 63C62.0711 61.1559 66.2917 56.6226 66.9191 49.0003C67.0097 47.8995 67.8949 47 68.9995 47H70Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 47C29.1046 47 30.0124 47.8996 29.8843 48.9967C28.963 56.8909 22.6504 63 15 63C20.0711 61.1559 24.2917 56.6226 24.9191 49.0003C25.0097 47.8995 25.8949 47 26.9995 47H28Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 47C29.1046 47 30.0124 47.8996 29.8843 48.9967C28.963 56.8909 22.6504 63 15 63C20.0711 61.1559 24.2917 56.6226 24.9191 49.0003C25.0097 47.8995 25.8949 47 26.9995 47H28Z",
    fill: "#2974B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRegulation);
export default __webpack_public_path__ + "static/media/imgRegulation.bd7523d878c384aceb95e81a4a72b0b8.svg";
export { ForwardRef as ReactComponent };